import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown, Phone, Menu, X, ExternalLink, Mail } from 'lucide-react';
import { LOGOS, CONTACT, NAV } from '../lib/constants';
import { Button } from './ui/Button';
function UtilityBar() {
  return <div className="hidden w-full bg-navy text-white lg:block" data-id="element-68">
      <div className="mx-auto flex max-w-content items-center justify-between px-8 py-2 text-[13px]" data-id="element-69">
        <p className="text-white/80" data-id="element-70">
          <span className="font-semibold text-ct-light" data-id="element-71">
            Independent IT Review
          </span>
          <span className="text-white/60" data-id="element-72">
            {' '}
            — clarity before you make a change.
          </span>
        </p>
        <div className="flex items-center gap-6" data-id="element-73">
          <a href="#portal" className="flex items-center gap-1.5 text-white/85 transition-colors hover:text-white" data-id="element-74">
            <ExternalLink className="h-3.5 w-3.5" aria-hidden data-id="element-75" />
            Client Portal
          </a>
          <a href={CONTACT.phoneHref} className="flex items-center gap-1.5 text-white/85 transition-colors hover:text-white" data-id="element-76">
            <Phone className="h-3.5 w-3.5" aria-hidden data-id="element-77" />
            {CONTACT.phone}
          </a>
          <a href={CONTACT.emailHref} className="flex items-center gap-1.5 text-white/85 transition-colors hover:text-white" data-id="element-78">
            <Mail className="h-3.5 w-3.5" aria-hidden data-id="element-79" />
            {CONTACT.email}
          </a>
        </div>
      </div>
    </div>;
}
function DesktopNav() {
  const [open, setOpen] = useState<string | null>(null);
  const closeTimer = useRef<number | null>(null);
  const enter = (label: string) => {
    if (closeTimer.current) window.clearTimeout(closeTimer.current);
    setOpen(label);
  };
  const leave = () => {
    closeTimer.current = window.setTimeout(() => setOpen(null), 120);
  };
  return <nav aria-label="Primary" className="hidden items-center gap-1 lg:flex" data-id="element-80">
      {NAV.map(item => <div key={item.label} className="relative" onMouseEnter={() => enter(item.label)} onMouseLeave={leave} data-id="element-81">
          <button className="flex items-center gap-1 rounded-lg px-3 py-2 text-[15px] font-semibold text-ink transition-colors hover:text-ct-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ct-cyan" aria-expanded={open === item.label} aria-haspopup="true" onFocus={() => enter(item.label)} data-id="element-82">
            {item.label}
            <ChevronDown className={`h-4 w-4 transition-transform ${open === item.label ? 'rotate-180' : ''}`} aria-hidden data-id="element-83" />
          </button>
          {open === item.label && <div className="absolute left-0 top-full z-50 mt-1 w-64 rounded-card border border-border bg-white p-2 shadow-xl shadow-navy/10" role="menu" data-id="element-84">
              {item.children.map(c => <a key={c.label} href="#" role="menuitem" className="flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-[14px] font-medium text-ink transition-colors hover:bg-mist" data-id="element-85">
                  {c.accent && <span className="h-2.5 w-2.5 flex-shrink-0 rounded-full" style={{
            background: c.accent
          }} aria-hidden data-id="element-86" />}
                  <span className={c.accent ? '' : 'ml-[calc(0.625rem+0.625rem)]'} data-id="element-87">
                    {c.label}
                  </span>
                </a>)}
            </div>}
        </div>)}
    </nav>;
}
function MobileMenu({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  const [expanded, setExpanded] = useState<string | null>(null);
  return <div className={`fixed inset-0 z-[60] lg:hidden ${open ? '' : 'pointer-events-none'}`} aria-hidden={!open} data-id="element-88">
      <div className={`absolute inset-0 bg-navy/50 transition-opacity ${open ? 'opacity-100' : 'opacity-0'}`} onClick={onClose} data-id="element-89" />
      <div className={`absolute right-0 top-0 flex h-full w-[86%] max-w-sm flex-col bg-white shadow-2xl transition-transform duration-300 ${open ? 'translate-x-0' : 'translate-x-full'}`} role="dialog" aria-label="Menu" data-id="element-90">
        <div className="flex items-center justify-between border-b border-border px-5 py-4" data-id="element-91">
          <img src={LOGOS.main} alt="CT Group" className="h-8" data-id="element-92" />
          <button onClick={onClose} aria-label="Close menu" className="flex h-11 w-11 items-center justify-center rounded-lg text-ink hover:bg-mist" data-id="element-93">
            <X className="h-6 w-6" aria-hidden data-id="element-94" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-4 py-4" data-id="element-95">
          {NAV.map(item => <div key={item.label} className="border-b border-border/70" data-id="element-96">
              <button className="flex w-full items-center justify-between py-3.5 text-[16px] font-bold text-ink" onClick={() => setExpanded(expanded === item.label ? null : item.label)} aria-expanded={expanded === item.label} data-id="element-97">
                {item.label}
                <ChevronDown className={`h-5 w-5 transition-transform ${expanded === item.label ? 'rotate-180' : ''}`} aria-hidden data-id="element-98" />
              </button>
              {expanded === item.label && <div className="pb-3" data-id="element-99">
                  {item.children.map(c => <a key={c.label} href="#" className="flex items-center gap-2.5 py-2.5 pl-1 text-[15px] text-slate" data-id="element-100">
                      {c.accent && <span className="h-2 w-2 rounded-full" style={{
                background: c.accent
              }} aria-hidden data-id="element-101" />}
                      {c.label}
                    </a>)}
                </div>}
            </div>)}
        </div>
        <div className="space-y-3 border-t border-border px-5 py-4" data-id="element-102">
          <Button as="a" href="#it-review" variant="primary" full data-id="element-103">
            Book an IT Review
          </Button>
          <Button as="a" href={CONTACT.phoneHref} variant="outline" full data-id="element-104">
            <Phone className="h-4 w-4" aria-hidden data-id="element-105" /> {CONTACT.phone}
          </Button>
        </div>
      </div>
    </div>;
}
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="sticky top-0 z-50 w-full" data-id="element-106">
      <UtilityBar data-id="element-107" />
      <div className={`w-full border-b transition-all duration-300 ${scrolled ? 'border-border bg-white/90 shadow-sm backdrop-blur-md' : 'border-border/60 bg-white'}`} data-id="element-108">
        <div className="mx-auto flex max-w-content items-center justify-between gap-4 px-5 py-3 md:px-8" data-id="element-109">
          <a href="#top" className="flex-shrink-0" aria-label="CT Group home" data-id="element-110">
            <img src={LOGOS.main} alt="CT Group" className="h-9 md:h-10" data-id="element-111" />
          </a>

          <DesktopNav data-id="element-112" />

          <div className="hidden items-center gap-3 lg:flex" data-id="element-113">
            <a href={CONTACT.phoneHref} className="flex items-center gap-1.5 text-[15px] font-semibold text-ink transition-colors hover:text-ct-deep" data-id="element-114">
              <Phone className="h-4 w-4 text-ct-cyan" aria-hidden data-id="element-115" />
              {CONTACT.phone}
            </a>
            <Button as="a" href="#it-review" variant="primary" data-id="element-116">
              Book an IT Review
            </Button>
          </div>

          <button className="flex h-11 w-11 items-center justify-center rounded-lg text-ink hover:bg-mist lg:hidden" aria-label="Open menu" onClick={() => setMobileOpen(true)} data-id="element-117">
            <Menu className="h-6 w-6" aria-hidden data-id="element-118" />
          </button>
        </div>
      </div>

      <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} data-id="element-119" />
    </header>;
}